<table class="table table-striped mt-3">
  <tbody>
    @if (historyItems.length > 0) {
      @for (clientTaskHistoryItem of historyItems; track clientTaskHistoryItem) {
        <tr>
          <td class="highlighted">
            <div>{{ clientTaskHistoryItem.createdAt | date: 'MM/dd/yyyy' }}</div>
            <div>{{ clientTaskHistoryItem.createdAt | date: 'hh:mm a' }}</div>
          </td>
          <td>
            <div>
              @switch (clientTaskHistoryItem.action) {
                @case (clientTaskHistoryItemActions.created) {
                  <app-client-task-history-item-type-created
                    [clientTaskHistoryItem]="clientTaskHistoryItem" />
                }
                @case (clientTaskHistoryItemActions.transitioned) {
                  <app-client-task-history-item-type-transitioned
                    [clientTaskHistoryItem]="clientTaskHistoryItem" />
                }
                @case (clientTaskHistoryItemActions.submitted) {
                  <app-client-task-history-item-type-submitted
                    [clientTaskHistoryItem]="clientTaskHistoryItem" />
                }
                @default {
                  <app-client-task-history-item-type-base
                    [clientTaskHistoryItem]="clientTaskHistoryItem" />
                }
              }
            </div>
          </td>
          <td class="highlighted">{{ clientTaskHistoryItem | historyItemUserName }}</td>
        </tr>
      }
    } @else {
      <tr>
        <td>There are no history items.</td>
      </tr>
    }
  </tbody>
</table>
